import "./styles.less";

import React, { FC, useContext } from "react";
import { ImagenOptimizada } from "../../Image/_new_web";
import { Tooltip } from "shared-components/Components/Tooltip/web";
import { CheckIcon } from "shared-components/Components/CustomIcons/CheckIcon/web";
import { Avatar } from "antd";
import { PhoneButton } from "../InformationRequest/LeadButtons/PhoneButton/web";
import { Owner } from "shared-components";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { getInmoLink } from "src/utils/Functions";
import usePropertyData from "src/hooks/propertyData/usePropertyData";

interface OwnerLogoProps {
	loading?: boolean;
	type?: "full" | "small";
	owner: Partial<Owner>;
}

export const OwnerLogo: FC<OwnerLogoProps> = ({
	loading = false,
	type = "small",
	owner
}) => {
	if (loading) return <></>;

	const { listing } = usePropertyData();
	const { country_code } = useContext(ConfigStateContext);
	const { logo, name, inmofull: inmoFull, masked_phone: maskedPhone, inmoLink: ownerInmoLink, inmoLinkProps, particular, id } = owner;

	const inmoLink = country_code === "CO" && particular === false ? getInmoLink(id, name) : ownerInmoLink;

	return (
		<OwnerLogoWrapper link={inmoLink || inmoLinkProps} name={name} >
			<div className="property-owner-logo">
				<div style={{position: 'relative'}}>
					{logo ? (
						<ImagenOptimizada src={logo} alt={name} width={110} height={50} />
					) : (
						<Avatar alt={name}>{name[0]?.toUpperCase()}</Avatar>
					)}

					{inmoFull && type == "small" &&
						<Tooltip text="Inmobiliaria Verificada" className="verificado">
							<CheckIcon />
						</Tooltip>
					}
				</div>

				{type == "full" && (
					<div style={{ display: "flex", flexDirection: "column", justifyContent: "center"}}>
						<strong  className="owner-name-text" style={{color:"#000", fontWeight:"bold"}}>{name}</strong>
						{inmoFull && (
							<div className="verificadoFull">
								<CheckIcon />
								{"Inmobiliaria Verificada"}
							</div>
						)}

						{maskedPhone && country_code !== "CO" && <PhoneButton type="viewPhone" owner={owner} icon id={listing.id} isProject={listing.isProject} />}
					</div>
				)}
			</div>
		</OwnerLogoWrapper>
	);
};

const OwnerLogoWrapper = ({ link, name, children }) => link
	? <a href={link} target="_blank" title={`${name}`}>{children}</a>
	: <>{children}</>;
